<template>
  <div class="user-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.uuid != null">
              <b-col cols="3">
                <b-form-group v-bind:label="$t('avatar')">
                  <b-form-file id="avatarData" @change="previewImage" ref="avatar" accept="image/*"></b-form-file>
                </b-form-group>
                <div class="image-desktop-preview">
                  <img class="preview-image" :src="avatarData != '' ? avatarData : item.avatar">
                </div>
              </b-col>

              <b-col cols="9">
                <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name"
                                aria-describedby="nameFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('username')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.username"
                                aria-describedby="usernameFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('email')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.email"
                                aria-describedby="emailFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('password')" :label-cols="3" :horizontal="true">
                  <b-form-input type="password" class="form-control" v-model="item.password"
                                aria-describedby="passwordFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('confirm_password')" :label-cols="3" :horizontal="true">
                  <b-form-input type="password" class="form-control" v-model="item.password_confirmation"
                                aria-describedby="passwordConfirmationFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('store')" :label-cols="3" :horizontal="true">
                  <b-form-select v-model="item.store_code" :options="outlets[$session.get('lang')]">
                  </b-form-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-bind:checked="item.active" v-model="item.active" :value="1"
                            :uncheckedValue="0"/>
                </b-form-group>

              </b-col>
              <b-col cols="12">
                <hr/>
              </b-col>
              <b-col cols="3" v-for="role in roles" :key="role.code">
                <label class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" v-bind:value="role.id" name="roles[]"
                         v-bind:checked="_.indexOf(item.roleIds, role.id) >= 0 ? true : false"
                         @change="updatePermission">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label">
                  <small class="text-muted">{{ role.name }}</small>
                </legend>
                <div class="role-permissions">
                  <div class="role-permission" v-for="permission in role.permissions" :key="permission.id">
                    <input type="hidden" v-bind:value="permission.id"/>
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <hr/>
              </b-col>
              <div class="col-3" v-for="permission in permissions" :key="permission.code">
                <label
                  v-bind:class="'switch switch-icon switch-' + (checkPermissionInRole(permission.id) ? 'secondary' : 'primary')">
                  <input type="checkbox" class="switch-input" v-bind:value="permission.id" name="roles[]"
                         v-bind:checked="checkPermission(permission.id)"
                         @change="updateRole"
                  >
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label">{{permission.name}}
                  <small class="text-muted">{{ permission.description }}</small>
                </legend>
              </div>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="uuid != null && $auth.check(model + '.update')">
                <i class="fa fa-save"></i> {{$t('update')}}
              </b-button>
              <b-button variant="success" v-on:click="createItem" v-if="uuid == null && $auth.check(model + '.create')">
                <i class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .preview-image {
    width: 100%;
  }

  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }

  .role-permissions {
    width: calc(70% - 30px);
    margin-left: calc(30% + 15px);
  }

  .role-permission {
    width: 50%;
    float: left;
  }
</style>
<script>
  import cSwitch from '../../../components/Switch'
  import {get, create, update, getListOutlet} from '@/api/user'
  import {getRolePermission} from '@/api/role'

  export default {
    name: 'UserForm',
    props: {
      uuid: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'user',
        roles: [],
        permissions: [],
        item: {
          uuid: null,
          avatar: '',
          username: '',
          email: '',
          name: '',
          password: '',
          password_confirmation: '',
          store_code: '',
          active: 0,
          roles: [],
          roleIds: [],
          permissions: [],
          permissionIds: [],
          permissionIdsInRoles: []
        },
        avatarData: 'https://bodiezpro.com/wp-content/uploads/2015/09/medium-default-avatar.png',
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Check on/off of permission switch
       * @param id of permission
       * @returns {boolean}
       */
      checkPermission(id) {
        if (_.indexOf(this.item.permissionIds, id) >= 0) {
          return true
        }
        return false
      },
      /**
       * Check disable of permission switch
       * @param id of permission
       * @returns {boolean}
       */
      checkPermissionInRole(id) {
        if (_.indexOf(this.item.permissionIdsInRoles, id) >= 0) {
          return true
        }
        return false
      },
      /**
       * Show preview image after select
       * @param event
       */
      previewImage(event) {
        let input = event.target

        if (input.files && input.files[0]) {
          let reader = new FileReader()

          reader.onload = (e) => {
            this[input.id] = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.item.avatar = input.files[0]
        }
      },
      /**
       * Update permission of Role
       * @param val of switch
       */
      updatePermission(val) {
        if (!val.target.checked) {
          for (let i in this.item.roles) {
            if (this.item.roles[i].id == val.target.value) {
              let permissionIds = []
              for (let j in this.item.roles[i].permissions) {
                permissionIds.push(this.item.roles[i].permissions[j].id)
              }

              let permissions = []
              this.item.permissions.forEach(function (item, k) {
                if (_.indexOf(permissionIds, item.id) < 0) {
                  permissions.push(item)
                }
              })
              this.item.permissions = permissions
              this.item.roles.splice(i, 1)
            }
          }
        } else {
          for (let i in this.roles) {
            if (this.roles[i].id == val.target.value) {
              if (_.indexOf(this.item.roleIds, val.target.value) < 0) {
                this.item.roles.push(this.roles[i])
              }
              break
            }
          }
        }
        this.updateUserRolePermission()
      },
      /**
       * Update Role of item
       * @param val of switch
       */
      updateRole(val) {
        if (!val.target.checked) {
          for (let i in this.item.permissions) {
            if (this.item.permissions[i].id == val.target.value) {
              this.item.permissions.splice(i, 1)
            }
          }

          for (let i in this.item.permissionIds) {
            if (this.item.permissionIds[i] == val.target.value) {
              this.item.permissionIds.splice(i, 1)
            }
          }

          let roles = []
          for (let i in this.item.roles) {
            let role = this.item.roles[i]
            let permissions = []
            // check enough permission for exist role of user
            for (let j in role.permissions) {
              if (_.indexOf(this.item.permissionIds, role.permissions[j].id) >= 0) {
                permissions.push(role.permissions[j])
              }
            }

            // enough permissions for exist role of user
            if (role.permissions.length == permissions.length) {
              roles.push(role)
            } else {
              // add permission to user
              for (let i in permissions) {
                this.item.permissions.push(permissions[i])
              }
            }
          }

          // set new roles
          this.item.roles = roles
        } else {
          // add new permission to user
          for (let i in this.permissions) {
            if (this.permissions[i].id == val.target.value && _.indexOf(this.item.permissionIds, val.target.value) < 0) {
              this.item.permissions.push(this.permissions[i])
              this.item.permissionIds.push(parseInt(val.target.value))
            }
          }

          for (let i in this.roles) {
            let role = this.roles[i]

            // check enough permission for new role
            let permissionIds = []
            for (let j in role.permissions) {
              if (_.indexOf(this.item.permissionIds, role.permissions[j].id) >= 0) {
                permissionIds.push(role.permissions[j].id)
              }
            }

            // enough permissions for new role of user
            if (role.permissions.length == permissionIds.length && _.indexOf(this.item.roleIds, role.id) < 0) {
              this.item.roles.push(role)
            }
          }
        }

        this.updateUserRolePermission()
      },
      /**
       * Update roles/permissions of item
       * @returns {item|{uuid, avatar, username, email, name, password, password_confirmation, active, roles, roleIds, permissions, permissionIds, permissionIdsInRoles}}
       */
      updateUserRolePermission() {
        let permissionIds = []
        let permissions = []
        for (let i in this.item.permissions) {
          if (_.indexOf(permissionIds, this.item.permissions[i].id) < 0) {
            permissionIds.push(this.item.permissions[i].id)
            permissions.push(this.item.permissions[i])
          }
        }

        let roleIds = []
        let permissionIdsInRoles = []
        for (let i in this.item.roles) {
          if (_.indexOf(roleIds, this.item.roles[i].id) < 0) {
            roleIds.push(this.item.roles[i].id)
            for (let j in this.item.roles[i].permissions) {
              if (_.indexOf(permissionIds, this.item.roles[i].permissions[j].id) < 0) {
                permissionIds.push(this.item.roles[i].permissions[j].id)
                permissions.push(this.item.roles[i].permissions[j])
              }
              if (_.indexOf(permissionIdsInRoles, this.item.roles[i].permissions[j].id) < 0) {
                permissionIdsInRoles.push(this.item.roles[i].permissions[j].id)
              }
            }
          }
        }

        this.item = {
          uuid: this.item.uuid,
          avatar: this.item.avatar,
          username: this.item.username,
          email: this.item.email,
          name: this.item.name,
          password: this.item.password,
          password_confirmation: this.item.password_confirmation,
          active: this.item.active,
          roles: this.item.roles,
          roleIds: roleIds,
          permissions: permissions,
          permissionIds: permissionIds,
          permissionIdsInRoles: permissionIdsInRoles
        }

        return this.item
      },
      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let data = {
          uuid: this.uuid
        }
        get(data).then((response) => {
          this.item = response.data.data
          this.avatarData = this.item.avatar
          this.updateUserRolePermission()
          this.item.store_code = response.data.data.user_outlets[0] != null ? response.data.data.user_outlets[0].outlet_code : ''
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get list roles/permissions for ui
       * @param cb
       */
      getRolePermissions(cb) {
        this.$Progress.start()
        getRolePermission().then((response) => {
          this.roles = response.data.data.roles
          this.permissions = response.data.data.permissions
          cb()
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let formData = new FormData()

        for (let i in this.item.permissionIds) {
          if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
            formData.append('permissionIds[]', this.item.permissionIds[i])
          }
        }
        for (let i in this.item.roleIds) {
          formData.append('roleIds[]', this.item.roleIds[i])
        }

        for (let i in this.item) {
          if (i != 'permissionIds' && i != 'roleIds' && i != 'permissions' && i != 'roles' && i != 'permissionIdsInRoles') {
            if (this.item[i] == null) {
              this.item[i] = ''
            }
            formData.append(i, this.item[i])
          }
        }

        update(formData).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let formData = new FormData()

        for (let i in this.item.permissionIds) {
          if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
            formData.append('permissionIds[]', this.item.permissionIds[i])
          }
        }
        for (let i in this.item.roleIds) {
          formData.append('roleIds[]', this.item.roleIds[i])
        }

        for (let i in this.item) {
          if (i != 'permissionIds' && i != 'roleIds' && i != 'permissions' && i != 'roles' && i != 'permissionIdsInRoles') {
            formData.append(i, this.item[i])
          }
        }

        create(formData).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get list outlets
       */
      getListOutlets() {
        this.$Progress.start()
        getListOutlet().then((response) => {
          this.outlets = {}
          let langs = Object.keys(this.$i18n.messages)
          for (let l in langs) {
            this.outlets[langs[l]] = []
            for (let i in response.data.data) {
              this.outlets[langs[l]].push({
                text: response.data.data[i].name,
                value: response.data.data[i].store_code
              })
            }
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      let langs = Object.keys(this.$i18n.messages)
      this.outlets = {}
      for (let l in langs) {
        this.outlets[langs[l]] = []
      }
      this.getListOutlets()
      this.getRolePermissions(() => {
        if (this.uuid != null) {
          this.getDetails()
        } else {
          this.item.uuid = ''
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/user/Form.vue